module.exports = __webpack_public_path__ + "img/default-nav-subnav-chevy.8e93b3af.png";